import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, BookUser } from "lucide-react";
import { NavbarData } from "../../Data/Navbardata";
import { mainRouteInitial } from "../../Data/Constant";
import { setRefreshKey } from "../../Redux/Slices/ProjectSlice";
import "./index.css";

const BottomMenuBar = () => {
  const { refreshKey, DarkTheme } = useSelector((state) => state.ProjectSlice);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleRefresh = () => {
    dispatch(setRefreshKey((refreshKey || 0) + 1));
  };

  const renderIcon = (iconClass) => {
    switch (iconClass) {
      case "dashboard":
        return <LayoutDashboard size={18} strokeWidth={2} className="bottom-menu-icon" />;
      case "address-book":
        return <BookUser size={18} strokeWidth={2} className="bottom-menu-icon" />;
      default:
        return <i className={`bottom-menu-icon ti tabler-${iconClass}`} />;
    }
  };

  return (
    <nav className={`bottom-menu-bar ${DarkTheme ? "darkMode" : ""}`} aria-label="Sub Navigation">
      <div className="bottom-menu-container">
        <ul className="bottom-menu-inner">
          {NavbarData?.map((ele, index) => {
            const isExternal = ele?.isExternal;
            const fullPath = isExternal
              ? ele?.pathUrl
              : `/${mainRouteInitial}/${ele?.pathUrl}`;

            const isDashboardTab = ele?.pathUrl === "VidhanSabhaDashboard" || ele?.pathUrl === "Dashboard";
            const isDashboardOrVidhanSabhaRoute =
              location.pathname.includes("VidhanSabhaDashboard") || location.pathname.includes("Dashboard");

            return (
              <li key={index} className="bottom-menu-item">
                {isExternal ? (
                  <a
                    href={fullPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bottom-menu-link"
                    title={ele?.titleText}
                  >
                    {renderIcon(ele?.iconClass)}
                    <span className="bottom-menu-text">{ele?.titleText}</span>
                  </a>
                ) : (
                  <NavLink
                    to={fullPath}
                    className={({ isActive }) =>
                      `bottom-menu-link ${
                        isActive || (isDashboardTab && isDashboardOrVidhanSabhaRoute) ? "active" : ""
                      }`
                    }
                    onClick={handleRefresh}
                    title={ele?.titleText}
                  >
                    {renderIcon(ele?.iconClass)}
                    <span className="bottom-menu-text">{ele?.titleText}</span>
                  </NavLink>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default BottomMenuBar;
